import sendEvent from './analytics-wrapper';
import { navigate } from '../navigate';

const trackSortByOrder = () => {
    const sortByOrder = document.querySelector<HTMLElement>('.js-wio__hd')?.dataset.sortBy;

    if (sortByOrder !== undefined) {
        sendEvent({
            category: 'Sort by',
            action: sortByOrder,
            label: navigate.getHref(),
        });
    }
};

export default trackSortByOrder;
